export const todayISO = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1); // tomorrow
  return d.toISOString().split('T')[0];
};